import ExternalLink from './ExternalLink';
import StoreBadges from './StoreBadges';
import useReveal from '../hooks/useReveal';
import { externalLinks } from '../config/links';

export default function FinalCta() {
  const [ref, isRevealed] = useReveal(0.2);

  return (
    <section className={`final-cta ${isRevealed ? 'is-revealed' : ''}`} ref={ref}>
      <div className="final-cta__panel reveal">
        <h2 className="section-title">Bring every angle of your event together.</h2>
        <p className="section-lead">
          Set up your collection now and share it before the first guest arrives.
        </p>

        <div className="final-cta__actions">
          <ExternalLink
            className="button button--primary"
            href={externalLinks.console}
            newTabHint
          >
            Open Console
          </ExternalLink>
          <StoreBadges />
        </div>
      </div>
    </section>
  );
}
